/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Checklist_Group_ExpandInputs */

const en_checklist_group_expand = /** @type {(inputs: Checklist_Group_ExpandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show ${i?.group}`)
};

const pt_br2_checklist_group_expand = /** @type {(inputs: Checklist_Group_ExpandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mostrar ${i?.group}`)
};

/**
* | output |
* | --- |
* | "Show {group}" |
*
* @param {Checklist_Group_ExpandInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const checklist_group_expand = /** @type {((inputs: Checklist_Group_ExpandInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checklist_Group_ExpandInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checklist_group_expand(inputs)
	return pt_br2_checklist_group_expand(inputs)
});